import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showHeaderRight: false,
};

export const showHeaderRightSlice = createSlice({
  name: "showHeaderRight",
  initialState,
  reducers: {
    isShowHeaderRight: (state, action) => {
      state.showHeaderRight = !state.showHeaderRight;
    },
  },
});

export const { isShowHeaderRight } = showHeaderRightSlice.actions;

export default showHeaderRightSlice.reducer;